module.exports = require('./helpers/bundle-url').getBundleURL('2FVrc') + "logo.c51670a8.svg";